<div class="grid-x minor-margin-top minor-margin-bottom">
  <div class="cell checkbox">
    <input class="no-margin vertical-align-text-bottom show-for-sr" type="checkbox" id="useRadios" [(ngModel)]="componentData.config.useRadioButtons" (ngModelChange)="radioChanged()" />
    <label for="useRadios">
      <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
      Show Radio Button Options
    </label>
  </div>
  @if (showChangeWarning) {
    <div class="cell red bold">
      <p>
        When changing from using radio buttons to not (or vice versa) any required field validation on this control needs to be removed and re-added using the appropriate type to ensure that it works correctly.
      </p>
    </div>
  }
  @if (componentData.config.useRadioButtons) {
    <div class="cell bold">
      Standard Options for Radio Buttons:
    </div>
    <div class="cell small-2 small-font-size bold">
      Use Option
    </div>
    <div class="cell small-4 small-font-size bold padding-right-small">
      Option Text
    </div>
    <div class="cell small-2 small-font-size bold">
      Show Text
    </div>
    <div class="cell small-2 small-font-size bold">
      Show Upload
    </div>
    <div class="cell small-2 small-font-size bold padding-left">
      Order
    </div>
    @for (option of componentData.config.radioOptions; track option) {
      <div class="cell small-2 checkbox">
        <input class="no-margin vertical-align-text-bottom show-for-sr" type="checkbox" [attr.id]="option.id + 'included'" [(ngModel)]="option.included" />
        <label [attr.for]="option.id + 'included'" class="small-font-size">
          <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
          @if (option.included) {
            Include
          }
          @if (!option.included) {
            Not Included
          }
        </label>
      </div>
      <div class="cell small-4 padding-right-small">
        <input class="small-font-size" type="text" [(ngModel)]="option.displayText" />
      </div>
      <div class="cell small-2 checkbox">
        <input class="no-margin vertical-align-text-bottom show-for-sr" type="checkbox" [attr.id]="option.id + 'showsText'" [(ngModel)]="option.showsText" [disabled]="option.standardOption" />
        <label [attr.for]="option.id + 'showsText'" class="small-font-size">
          <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
          @if (option.showsText) {
            Show
          }
          @if (!option.showsText) {
            Hide
          }
        </label>
      </div>
      <div class="cell small-2 checkbox padding-left">
        <input class="no-margin vertical-align-text-bottom show-for-sr" type="checkbox" [attr.id]="option.id + 'showsUpload'" [(ngModel)]="option.showsUpload" [disabled]="option.standardOption" />
        <label [attr.for]="option.id + 'showsUpload'" class="small-font-size">
          <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
          @if (option.showsUpload) {
            Show
          }
          @if (!option.showsUpload) {
            Hide
          }
        </label>
      </div>
      <div class="cell small-2 padding-left">
        <input type="number" step="1" min="1" [(ngModel)]="option.displayOrder" (blur)="reorder()" />
      </div>
    }
    <div class="cell bold">
      Text to Display when File Upload is Hidden:
    </div>
    <div class="cell">
      <div [froalaEditor]="froalaOptions" [(ngModel)]="componentData.config.deliverText" (ngModelChange)="onDeliverTextChange()"></div>
    </div>
  }
</div>